import React from 'react'

import Headertwo from '../../Global/Headertwo';
import Servicedtlbred from '../../Services/Mainservicesdetails/Servicedtlbred';


import Footer from '../../Global/Footer';
import BackToTop from '../../Global/BackToTop';

const Main = () => {
    return (
        <>
            {/* <Preloader /> */}
            <Headertwo />
            <Servicedtlbred title="Resources" />
            {/* <Servicesdetails />
            <Ctaone /> */}
            <Footer />
            <BackToTop/>
        </>
    )
}
export default Main;